// stores/userStore.js

import { clearTokens } from '@/network/base/authAxios';
import { logOut } from '@/network/auth.service';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
  users: null,
  user: null,
  auth: null,
};

const actions = set => ({
  // getToken: authCode => {
  //   // return getAPIResponse(`/Auth/v1.0/tokens?authcode=${authCode}`)
  // },
  logout: async () => {
    try {
      await logOut();
    } catch (error) {
      console.error('Server logout failed:', error);
    } finally {
      clearTokens();
      set({ user: null, auth: false });

      // Clear any URL parameters (auth codes, state, etc.)
      window.history.replaceState({}, document.title, window.location.pathname);

      // Redirect to clean login page
      window.location.href = '/auth';
    }
  },
  setAuth: value => set({ auth: value }),
  setUser: value => set({ user: value }),
});

const getters = (_, get) => ({
  isLoggedIn: () => !!get().auth,
});

// export const useUserStore = create((set, get) => ({
//   ...initialState,
//   ...actions(set, get),
//   ...getters(set, get),
// }));

export const useUserStore = create(
  devtools(
    (set, get) => ({
      ...initialState,
      ...actions(set, get),
      ...getters(set, get),
    }),
    { name: 'UserStore' }
  )
);
